import { FC } from "react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import styled from "styled-components";

import { CHART_COLORS, formatEuro } from "../common/constants";
import { BuyerSegmentData } from "../common/types";

const StyledMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
`;

const StyledMetric = styled.div`
  padding: 1rem;
  background: #f5f5f5;
  border-radius: 6px;
  text-align: center;
`;

const StyledMetricValue = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  color: #2196f3;
`;

const StyledMetricLabel = styled.div`
  font-size: 0.9rem;
  color: #666;
  margin-top: 0.5rem;
`;

type BuyerSegmentationProps = {
  data: BuyerSegmentData[];
};

export const BuyerSegmentation: FC<BuyerSegmentationProps> = ({ data }) => {
  return (
    <>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data}
            dataKey="count"
            nameKey="segment"
            cx="50%"
            cy="50%"
            outerRadius={100}
            label={({ segment, percentage }) =>
              `${segment} (${percentage.toFixed(1)}%)`
            }
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={
                  [
                    CHART_COLORS.totalSpent,
                    CHART_COLORS.uniqueBuyers,
                    CHART_COLORS.badgePurchases,
                  ][index]
                }
              />
            ))}
          </Pie>
          <Tooltip formatter={(value: any, name: string) => [value, name]} />
        </PieChart>
      </ResponsiveContainer>

      <StyledMetrics>
        {data.map((segment) => (
          <StyledMetric key={segment.segment}>
            <StyledMetricValue>{segment.count}</StyledMetricValue>
            <StyledMetricLabel>{segment.segment}</StyledMetricLabel>
            {segment.totalSpent > 0 && (
              <div
                style={{
                  fontSize: "0.8rem",
                  color: "#666",
                  marginTop: "0.25rem",
                }}
              >
                {formatEuro(segment.totalSpent)} ({formatEuro(segment.avgSpent)}
                /pers)
              </div>
            )}
          </StyledMetric>
        ))}
      </StyledMetrics>
    </>
  );
};
